// Bank Transactions State

export default {
  transactionsList: [],
  transactionInfo: {}
}
